import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDownloadShield = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 26,
	viewBox: "0 0 23 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.1875 6.8964C22.2562 6.43974 22.2877 5.97839 22.282 5.51667C20.9043 4.08845 19.2517 2.95225 17.4232 2.17618C15.5948 1.4001 13.6281 1 11.641 1C9.65393 1 7.68732 1.4001 5.85888 2.17618C4.03045 2.95225 2.3778 4.08845 1 5.51667C1 22.0981 11.641 24.5865 11.641 24.5865C12.428 24.2543 13.1872 23.8599 13.9111 23.4072",
			stroke: "#333333",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 12V20",
			stroke: "#333333",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 17L19 20L16 17",
			stroke: "#333333",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconDownloadShield;
